import React from 'react';
import {connect} from 'react-redux';
import {orderBy, startCase} from 'lodash'


// local imports
import api from '../../../store/api'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import validators from "../../../utils/forms/validators";
import formatters from "../../../utils/forms/formatters";

import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import BaseModal from "../../theme/modals/BaseModal"
import FormModal from "../../theme/modals/FormModal";
import {toggleGlobalLoader, addErrorAlert} from "../../../store/calls/alertLoadingDispatch";
import SelectByCategory from "../../theme/forms/SelectByCategory";


export default class UserAdminScreen extends React.Component {

    constructor(props) {
        super(props);


        this.createEditInputs = [
            {
                type: 'text',
                label: "First Name",
                dataKey: "first_name",
            },
            {
                type: 'text',
                label: "Last Name",
                dataKey: "last_name",
            },
            {
                type: 'text',
                label: "Username",
                dataKey: "username",
            },
            {
                type: 'text',
                label: "Email",
                dataKey: "email",
            },
            {
                type: 'text',
                label: "password",
                dataKey: "password",
                placeholder: 'XX',
                // value: ' ',
            },
            {
                type: 'text',
                label: "Company",
                dataKey: "company",
            },
            {
                type: 'text',
                label: "Phone 1",
                dataKey: "phone_1",
            },
            {
                type: 'text',
                label: "Phone 2",
                dataKey: "phone_2",
            },

        ]

        this.state = {

            displayedData: [],
            dataPullLimit: 25,
            dataPullOffset: 0,

            // edit and delete
            editModalOpen: false,
            deleteModalOpen: false,
            editingInstance: null,

            permissionsModalOpen: false,

            userGroups: [],
            createEditInputs: this.createEditInputs,

            searchVal: null,
        }


    }

    componentDidMount() {
        toggleGlobalLoader(true);

        Promise.all([
            this.getData(),
            this.getUserGroups(),
        ])
        .then(() => toggleGlobalLoader(false))
    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }

    dataCallback = (data) => {
       return data.map(d => ({...d,  ...(d.profile || {}), last_login: formatters.date('iso', 'yyyy-MM-dd').formatter(d.last_login)}))
    }

    getUserGroups = () => {
        api.get('/permissions-groups/')
            .then(res => this.setState({
                userGroups: orderBy(res.data.map(d => ({...d, display_name: startCase(d.display_name)})), 'display_name')
            }))
    }

    getData = (xtraParams = {}) => {
        let params = {
            limit: this.state.dataPullLimit,
            offset: this.state.dataPullOffset,
            searchVal: this.state.searchVal,
            ...xtraParams
        }

        // if (this.state.stateFilter) params.state = this.state.stateFilter;
        // if (this.state.typeFilter) params.type = this.state.typeFilter;
        // if (this.state.nameFilter) params.name = this.state.nameFilter;

        // if (this.state.state)
        return api.get('/users/', params)
            .then((res) => {
                return this.dataCallback(res.data.results)
            })
            .then(data => {
                this.setState({displayedData: data})
            })
            .catch(() => addErrorAlert('User data failed to load.'))
    }

    handleLimitChange = (val) => {
        this.setState({dataPullLimit: val}, this.getData)
    }

    handleOffsetChange = (val) => {
        this.setState({dataPullOffset: val}, this.getData)
    }

    populateInputsWithValues = () => {
        return this.state.createEditInputs.map(d => ({
            ...d,
            value: this.state.editingInstance ? this.state.editingInstance[d.dataKey] : ''
        }))

    }

    handleDeleteRequest = () => {
        api.patch(`/users/${this.state.editingInstance.id}/`, {is_active: 0})
            .then(() => this.getData())
            .catch(err => addErrorAlert('Deletion failed. Please try again.'))
            .finally(() => this.setState({deleteModalOpen: false, editingInstance: null}))
    }

    handleCreateOrUpdateRequest = (data, pullAll = true) => {
        if (data.group) {
            data.groups = [data.group, ...(data.groups ? data.groups : [])]
        }
        let promise;
        if (this.state.editingInstance) {

            promise = () => api.patch(`/users/${this.state.editingInstance.id}/`, data)
        } else {
            promise = () => api.post('/users/', data)
        }

        return promise()
            .then(() => pullAll ? this.getData() : null)
            .catch(err => {
                addErrorAlert(JSON.stringify(err.response?.data))
            })
            .finally(() => pullAll ? this.setState({editModalOpen: false, editingInstance: null}) : null)
    }


    handleSearch = (val) => {
        this.setState({searchVal: val}, this.getData)
    }

    buildGroupOptionsForAssignment = () => {
        let already_assigned = (this.state.editingInstance || {groups: []}).groups.map(d => d.id);
        let is_admin = already_assigned.includes(1);
        let options = this.state.userGroups.map(d => ({...d, category: "User Groups"}))


        if (is_admin) {
             options = options.map(d => d.id === 1 ? d : {...d, disabled: true})
        }

        console.log("options", options)
        if (already_assigned.length) {
            options = [...options.map(d => ({...d, selected: already_assigned.includes(d.id)}))]
                .sort((a,b) => (b.selected ? 1 : 0) - (a.selected ? 1 : 0))
            console.log("options after sort", options)
        }

        return options
    };

    handleGroupAssignmentOrDeletion = (creation = true, group_id) => {
        let group = this.state.userGroups.find(d => d.id === group_id);
        if (!group) addErrorAlert("There was an error, we can seem to process the group you selected.")

        let newgroups = !creation ?
            this.state.editingInstance.groups.filter(d => d.id !== group.id) :
            [...this.state.editingInstance.groups, group];

        console.log(creation, newgroups)

        let callback = () => this.handleCreateOrUpdateRequest({groups: newgroups.map(d => d.id)}, false);

        this.setState({
            editingInstance: {...this.state.editingInstance, groups: newgroups}
        }, callback)
    }

    render() {
        return (
            <AdminWrapper>
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <h2 className="title is-2">Manage Users</h2>
                                </div>
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    <button
                                        className='button is-link'
                                        onClick={() => this.setState({editModalOpen: true})}
                                    >+ Create User</button>
                                </div>
                            </div>
                        </div>
                        <PaginatedTable
                            className="is-fullwidth is-hoverable"
                            data={this.state.displayedData.map(d => ({...(d.profile || {}), ...d}))}
                            columns={['first_name', 'last_name', 'username', 'email', 'company', 'last_login']}
                            pullLimit={this.state.dataPullLimit}
                            handleLimitChange={this.handleLimitChange}
                            pullOffset={this.state.dataPullOffset}
                            handleOffsetChange={this.handleOffsetChange}
                            handleSearch={this.handleSearch}
                            actions={[
                                {
                                    name: 'Edit',
                                    elem: (<span className="icon has-text-info">
                                                <i className="fas fa-edit"/>
                                            </span>),
                                    action: (data) => this.setState({editModalOpen: true, editingInstance: {...data}})
                                },
                                {
                                    name: 'Permissions',
                                    elem: (<span className="icon has-text-info">
                                                <i className="fas fa-users-cog"/>
                                            </span>),
                                    action: (data) => this.setState({permissionsModalOpen: true, editingInstance: {...data}})
                                },
                                {
                                    name: 'Delete',
                                    elem: (<span className="icon has-text-danger">
                                                <i className="fas fa-minus-square"/>
                                            </span>),
                                    action: (data) => this.setState({deleteModalOpen: true, editingInstance: {...data}})
                                }
                            ]}
                        />

                    </div>
                </div>

                <FormModal
                    title={this.props.editingInstance ? this.props.editingInstance.first_name + ' ' + this.props.editingInstance.last_name : 'Create a new User'}
                    visible={this.state.editModalOpen}
                    inputs={this.populateInputsWithValues()}
                    disableAutocomplete
                    onSubmit={this.handleCreateOrUpdateRequest}
                    onCancel={() => this.setState({editModalOpen: false, editingInstance: null})}
                    // otherButtons={[<button className={'button'} onClick={() => null}>Add Another</button>]}
                />
                <ConfirmModal
                    type="warning"
                    visible={this.state.deleteModalOpen && this.state.editingInstance}
                    prompt={!!this.state.editingInstance && `Are you sure you want to delete user ${this.state.editingInstance.first_name} ${this.state.editingInstance.last_name}?`}
                    onCancel={() => this.setState({deleteModalOpen: false, editingInstance: null})}
                    onAccept={this.handleDeleteRequest}
                />
                {this.state.permissionsModalOpen &&
                    <BaseModal
                        visible
                    >
                         <SelectByCategory
                             data={this.buildGroupOptionsForAssignment()}
                             displayKey="display_name"
                             wrapperStyle={{maxHeight: '50vh', overflowY: 'scroll'}}
                             onOptionValueChange={this.handleGroupAssignmentOrDeletion}
                             startExpanded
                         />
                         <div className="py-4">
                            <button
                            className="button is-success pull-right"
                            onClick={() => this.setState({permissionsModalOpen: false, editingInstance: null})}
                        >I'm done</button>
                         </div>
                 </BaseModal>
                }


            </AdminWrapper>
        )
    }

}

//
// let promise;
//
// if (deletion) {
//     promise = () => api.delete('/user-groups/', {user: this.state.editingInstance.id, group: group.id})
// } else {
//     promise = () => api.post('/user-groups/', {user: this.state.editingInstance.id, group: group.id})
// }
//
// promise()
//     .then(() => {
//         this.setState({editingInstance: {
//                 ...this.state.editingInstance,
//                 groups: deletion ?
//                     this.state.editingInstance.groups.filter(d => d.id !== group.id) :
//                     [...this.state.editingInstance.groups, group]
//             }})
//     })
//     .catch(() => addErrorAlert(`${deletion ? "Deletion" : "Creation"} of user group failed`))

